import { useEffect, useState } from "react";
import { fetchUser, addWatchlist, removeWatchlist, listWatchlist, startGoogleLogin } from "@/lib/userApi";
import { toast } from "sonner";

/** ★ / ☆ button — save a trend to a signed-in user's watchlist. */
export default function WatchStar({ trend }) {
  const [user, setUser] = useState(null);
  const [saved, setSaved] = useState(false);
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      const u = await fetchUser();
      setUser(u);
      if (u) {
        try {
          const list = await listWatchlist();
          setSaved(list.some((x) => x.trend_id === trend.id));
        } catch (e) { console.warn("watchlist check failed", e); }
      }
      setReady(true);
    })();
  }, [trend.id]);

  const onClick = async () => {
    if (!user) {
      toast("Sign in with Google to save trends", { duration: 3000 });
      setTimeout(() => startGoogleLogin(), 400);
      return;
    }
    setBusy(true);
    try {
      if (saved) {
        await removeWatchlist(trend.id);
        setSaved(false);
        toast.success("Removed from watchlist");
      } else {
        await addWatchlist(trend);
        setSaved(true);
        toast.success("Added to watchlist");
      }
    } catch (_) {
      toast.error("Could not update");
    }
    setBusy(false);
  };

  return (
    <button
      data-testid={`watch-star-${trend.id}`}
      onClick={onClick}
      disabled={busy || !ready}
      className={`hard-shadow inline-flex items-center gap-2 border border-black px-4 py-2 overline transition ${
        saved ? "bg-black text-white" : "bg-white text-black hover:bg-[#f4f4f5]"
      }`}
      aria-label={saved ? "Remove from watchlist" : "Add to watchlist"}
    >
      <span className={saved ? "text-[#ff3b30]" : ""}>{saved ? "★" : "☆"}</span>
      {saved ? "Saved" : "Watch"}
    </button>
  );
}
